/**
 * 
 * @author Jesus R. Nava Cruz
 * @company Erillam Healthcare
 * @version 1.0
 * 
 */

import ServicePath from "@/core/ServicePath";
import {
    MainRequest
} from "@/core/request";

export default class StudyModalityRequest extends MainRequest{

    static addStudyModality(data, ) {
        return this.postSEC(ServicePath.STUDY_MODALTY_ADD, data)
    }

    static allStudyModality() {
        return this.getSEC(ServicePath.STUDY_MODALTY_LIST_ALL)
    }

    static updateStudyModality(data, ) {
        return this.postSEC(ServicePath.STUDY_MODALTY_UPDATE, data)
    }

    static deleteStudyModality(data, ) {
        return this.postSEC(ServicePath.STUDY_MODALTY_DELETE, data)
    }

    static listStudyModalityByModalty(data) {
        return this.postSEC(ServicePath.STUDY_MODALTY_LIST_BY_MODALTY, data)
    }
    static listStudyModalityBySpecialityAndUser(idSpeciality, idModality) {
        return this.postSEC(ServicePath.STUDY_MODALTY_LIST_BY_SPECIALITY_AND_USER, {idSpeciality: idSpeciality, idModality: idModality})
    }

    static findAllByModalityAndBranchOfficeAndSpeciality(idModality, idSpeciality, idBranchOffice) {
        let params = {
            idModality: idModality,
            idSpeciality: idSpeciality,
            idBranchOffice: idBranchOffice
        };
        return this.postSEC(ServicePath.STUDY_MODALITY_ALL_BY_MODALITY_AND_BRANCH_OFFICE, params);
    }

}
